import React, { Component } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import styles from './Link.module.scss';

export default class Link extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    isBlank: PropTypes.bool.isRequired
  };

  render() {
    const { isBlank, title, url } = this.props;

    return (
      <>
        {isBlank ? (
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className={styles.Link}
          >
            {title}
          </a>
        ) : (
          <RouterLink to={url} className={styles.Link}>
            {title}
          </RouterLink>
        )}
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Link/Link.js